function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M23.207 2a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1.586l-2.209 2.209a7.5 7.5 0 10-7.008 13.2 4.483 4.483 0 00.423-2.01 5.5 5.5 0 113.996.395 8.487 8.487 0 01-.342 2.118 7.502 7.502 0 004.452-12.396l2.102-2.102V7a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V2.5a.5.5 0 00-.5-.5h-4.5z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 17.5a7.502 7.502 0 016.347-7.412 8.487 8.487 0 00-.342 2.118 5.5 5.5 0 103.996.395L14 12.5c0-.682.152-1.33.424-1.909A7.502 7.502 0 0112.5 24.934V26.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1h-1A.5.5 0 019 28v-1a.5.5 0 01.5-.5h1v-1.566A7.501 7.501 0 014 17.5z",
  fill: "currentColor"
})));